define('views/modules/questionnaire/questionnaire-link-modal',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils', 'services/i18n',
    // views
    'views/parts/modal/modal',
    // models
    'models/questionnaire/questionnaire',
    // templates
    'text!templates/modules/questionnaire/questionnaire-link-modal.html',
], function(
    // Libs
    _, Backbone, Mustache, U, i18n,
    // views
    VModal,
    // models
    MQuestionnaire,
    //templates
    TQuestionnaireLinkModal
) {
    var VQuestionnaireLinkModal = VModal.extend({
        template: TQuestionnaireLinkModal,
        regions: {},

        buttons: function() {
            return {
                confirm: {
                    label: i18n.t("Ok"),
                    callback: this.onCancel
                }
            };
        },

        modal: function() {
            return { title: i18n.t("questionnaire:Questionnaire link") };
        },

        initialize: function(opt) {
            this.model = new MQuestionnaire();
        },
        render: function() {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext({
                url: this.model.getAbsoluteUrl({
                    target: '_blank'
                })
            })));
            this.generateZones()
                .renderModal();

            return this;
        },

        setModel: function(model) {
            if (!model) return;
            var attrs = model.attributes || model;
            this.model.reset(attrs);
            return this;
        },

        ////////////
        // events //
        ////////////

    });

    return VQuestionnaireLinkModal;
});

